export class CreateLocationStateError extends Error {

}
